// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ts","sizeMedium":"e_us","sizeSmall":"e_vs","icon":"e_ws"};